import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useFetchEveryThirty from '../../hooks/useFetchEveryThirty';
import { fetchDashboardMyMarketsAndIndustries } from '../../redux/routines';
import DataTable from '../DataTable';
import If from '@components/If';
import MyMarketsSkeleton from './MyMarketsSkeleton';
import MyMarketsItem from './MyMarketsItem';
import track from 'react-tracking';
import type { Entity } from '../../redux/selectors/myMarketsAndIndustriesSelectors';

export interface Props {
  marketKeys: string[];
  industryKeys: string[];
  lastUpdated: number | null;
  entities: Record<string, Entity>;
}

const DeprecatedMyMarkets = ({
  marketKeys,
  industryKeys,
  lastUpdated,
  entities,
}: Props) => {
  const dispatch = useDispatch();
  const callback = useCallback(() => {
    dispatch(fetchDashboardMyMarketsAndIndustries.trigger());
  }, [dispatch]);
  const fetchStatus = useFetchEveryThirty(lastUpdated, callback);
  return (
    <DataTable columnWidths="4, 2, 2, 2" columnTextAlignments="l,r,r,r">
      <thead>
        <tr>
          <th></th>
          <th>7D</th>
          <th>1Y</th>
          <th>PE</th>
        </tr>
      </thead>
      <tbody>
        <If match={fetchStatus === 'fetching'}>
          <MyMarketsSkeleton />
        </If>
        <If match={fetchStatus === 'idle'}>
          {marketKeys.map((n, i) => (
            <MyMarketsItem
              key={n}
              id={n}
              name={`${entities[n].marketISO.toUpperCase()} Market`}
              slug={entities[n].marketISO}
              return7D={entities[n].return7D}
              return7DFormatted={entities[n].return7DFormatted}
              return1YrAbs={entities[n].return1YrAbs}
              return1YrAbsFormatted={entities[n].return1YrAbsFormatted}
              PERatio={entities[n].PERatio}
              PERatioFormatted={entities[n].PERatioFormatted}
              index={i}
            />
          ))}
          {industryKeys.map((n, i) => (
            <MyMarketsItem
              key={n}
              id={n}
              name={`${entities[n].marketISO.toUpperCase()} ${
                entities[n].industryName
              }`}
              slug={entities[n].industrySlug}
              return7D={entities[n].return7D}
              return7DFormatted={entities[n].return7DFormatted}
              return1YrAbs={entities[n].return1YrAbs}
              return1YrAbsFormatted={entities[n].return1YrAbsFormatted}
              PERatio={entities[n].PERatio}
              PERatioFormatted={entities[n].PERatioFormatted}
              index={i}
            />
          ))}
        </If>
      </tbody>
    </DataTable>
  );
};

export default track({
  type: 'track',
  subject: 'my_markets_module',
})(DeprecatedMyMarkets) as typeof DeprecatedMyMarkets;
